export default () => import(/* webpackChunkName: 'coffee/app/invite-unmanned-express' */ './InviteUnmannedExpress');
